<div class="search-bar">
	<div class="search-icon text-body-secondary">
		<i class="bi bi-search"></i>
	</div>
	<input type="search" [formControl]="control" class="form-control form-control-sm" [placeholder]="placeholder" />
</div>
